import { render } from "./Footer.vue?vue&type=template&id=6a4c1370&scoped=true&bindings={}"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=6a4c1370&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6a4c1370"

export default script